import { render, staticRenderFns } from "./xuliang_batch.vue?vue&type=template&id=71ca3d74&"
import script from "./xuliang_batch.vue?vue&type=script&lang=js&"
export * from "./xuliang_batch.vue?vue&type=script&lang=js&"
import style0 from "./xuliang_batch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports